import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { getCheapestSelectedPackageOption } from 'selectors/offerPage/offerPageSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

export const useOfferPageRate = (state: OfferPageState): App.OfferPackageOptionView | undefined => {
  const packageView: App.OfferPackageOptionView | undefined = useAppSelector(
    (appState) => getCheapestSelectedPackageOption(appState, state),
  )
  if (!packageView) return

  return {
    ...packageView,
    hotelPrice: packageView.hotelPrice + (packageView.propertyFees ?? 0),
  }
}
